import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const updateDraftLegacyScheduleTypes = api(async function updateDraftLegacyScheduleTypes({
    projectId,
    scheduleId,
    legacyScheduleTypes,
}) {
    return mutate(
        gql`
            mutation UpdateDraftLegacyScheduleTypes(
                $projectId: String!
                $scheduleId: String!
                $legacyScheduleTypes: [Int!]!
            ) {
                updateDraftLegacyScheduleTypes(
                    projectId: $projectId
                    scheduleId: $scheduleId
                    legacyScheduleTypes: $legacyScheduleTypes
                )
            }
        `,
        { projectId, scheduleId, legacyScheduleTypes },
        { returns: "updateDraftLegacyScheduleTypes" }
    )
})
